import { makeRequest } from '../../../../services/apiClient';

/**
 * Fetch dataset time span KPI from backend.
 * @param {string|null} fileType Optional OCEL file type (defaults to active file on backend)
 * @returns {Promise<{file_type:string,start_timestamp:string,end_timestamp:string,duration_seconds:number,duration_days:number,duration_weeks:number,duration_months_approx:number,pretty:string}>}
 */
export const fetchTimeSpanKPI = async (fileType = null) => {
  const params = fileType ? { file_type: fileType } : {};
  // KPI router is mounted at /api/kpi
  return await makeRequest('/kpi/time-span', { params }, 'time span KPI');
};
